import router from './router'

export default {
	moduleName: 'group',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/group/index.js